import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import React from "react";
import { useService } from "@/hooks/use-service";
import { EditServiceModal } from "@/modals/organizations/edit-service-modal";
import type { ServicePanelBaseProps } from "./shared";

export function ServiceMenu({ serviceId }: ServicePanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();
	const { refetch } = useService(serviceId);

	/** Render */
	return (
		<React.Fragment>
			<Button
				variant="primary"
				icon={<Icon name="Edit" />}
				onClick={disclosure.onOpen}
			>
				{t("general.edit")}
			</Button>
			{disclosure.isOpen && (
				<EditServiceModal
					{...disclosure}
					serviceId={serviceId}
					onComplete={async () => {
						refetch();
					}}
				/>
			)}
		</React.Fragment>
	);
}
